import React from "react";
import { useFormikContext, Field } from "formik";
import { Row, Col, Form } from "react-bootstrap";
import { Autocomplete, Box } from "@mui/material";
import BootstrapTextField from "Common/Components/InputComponent/BootstrapTextField";
import { QuotationFormValues } from "../initialValues";
import { MecordColors } from "Constants/Color";
import { autocompleteDropdownStyles } from "Constants/Style";

const emdModeOptions = ["BG", "DD", "NEFT/RTGS"];

const EMDSection: React.FC = () => {
  const { values, setFieldValue, errors, touched } = useFormikContext<QuotationFormValues>();
  const isEmdModeSelected = Boolean(values.mode_of_emd);

  return (
    <div className="rounded mb-3">
      <div className="d-flex justify-content-between align-items-center mb-3 gap-2">
        <h5 className="fw-semibold">EMD (Earnest Money Deposit) Details</h5>
      </div>
      <Row
        className="g-3 pb-3 px-1 rounded"
        // style={{ backgroundColor: MecordColors?.LightGrayColor }}
      >
        <Col xs={12} sm={6} md={6}>
          <Form.Group>
            <Form.Label>Mode of EMD</Form.Label>
            <Autocomplete
              options={emdModeOptions}
              getOptionLabel={(option: any) => option}
              isOptionEqualToValue={(option: any, value: any) =>
                option === value
              }
              value={values.mode_of_emd || null}
              onChange={(_: any, newValue: any) => {
                setFieldValue("mode_of_emd", newValue || "");
              }}
              ListboxProps={autocompleteDropdownStyles.ListboxProps}
              renderOption={(props, option, { selected }) => (
                <li {...props} style={{ padding: 0 }}>
                  <Box
                    sx={{
                      px: 1.5,
                      py: 0.8,
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: MecordColors.Hover,
                        color: MecordColors.ActiveText,
                      },
                      ...(selected && {
                        backgroundColor: MecordColors.ActiveBackground,
                        color: MecordColors.ActiveText,
                      }),
                    }}
                  >
                    <span>{option}</span>
                  </Box>
                </li>
              )}
              renderInput={(params: any) => (
                <BootstrapTextField
                  {...params}
                  placeholder="Select Mode of EMD"
                  size="small"
                  sx={autocompleteDropdownStyles.inputSx}
                />
              )}
            />
          </Form.Group>
        </Col>
        <Col xs={12} sm={6} md={6}>
          <Form.Group>
            <Form.Label>
              EMD Amount
              {isEmdModeSelected && <span className="text-danger"> *</span>}
            </Form.Label>
            <Field name="emd_amount">
              {({ field }: any) => (
                <Form.Control
                  {...field}
                  placeholder="Enter EMD Amount"
                  type="number"
                  isInvalid={touched.emd_amount && !!errors.emd_amount}
                />
              )}
            </Field>
            {touched.emd_amount && errors.emd_amount && (
              <Form.Control.Feedback type="invalid" className="d-block">
                {errors.emd_amount}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default EMDSection;
